import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { reinitialiseAPI, getAPI, postAPI } from 'store/apiReducer';
import { LoaderMi, Row, Col, Container } from '@si-armes/dsfr-react';
import PropTypes, { shape } from 'prop-types';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
} from '../../../../constants/apiUrls.constants';

const EcranGestion = ({
    reinitialiseApi,
    getApi,
    isLoading,
    dataCompteUsager,
    erreur,
    message,
    dataSuppression,
}) => {
    const recuperationInformations = () => {
        getApi(
            usagerClientReducer,
            API_RECUPERER_INFORMATIONS_PERSONNELLES,
            CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
        );
        return () => {
            reinitialiseApi(CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES);
        };
    };

    useEffect(() => {
        recuperationInformations();
    }, []);

    useEffect(() => {
        if (dataSuppression) {
            recuperationInformations();
        }
    }, [dataSuppression]);

    if (isLoading) {
        return (
            <>
                <div className="loader-full-screen">
                    <LoaderMi taille="md" />
                </div>
            </>
        );
    }
    if (erreur) {
        return (
            <div className="margin-top-md margin-bottom-md">
                <p>{message}</p>
            </div>
        );
    }
    if (!dataCompteUsager || !dataCompteUsager.compte || !dataCompteUsager.personnePhysique) {
        return (
            <div className="margin-top-md margin-bottom-md">
                <p>Une erreur s&apos;est produite !</p>
            </div>
        );
    }

    return (
        <Container fluid={false}>
            <Row>
                <Col col={12}>
                    <h1>Gestion de compte des employés</h1>
                </Col>
            </Row>

            <p>Page suivante gestion des employés de métier personne morale</p>
        </Container>
    );
};

EcranGestion.propTypes = {
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    dataCompteUsager: PropTypes.shape({
        compte: PropTypes.shape({
            dateDeCreation: PropTypes.string.isRequired,
            username: PropTypes.string.isRequired,
        }).isRequired,
        personnePhysique: PropTypes.shape({
            numeroSia: PropTypes.string.isRequired,
            nom: PropTypes.string.isRequired,
            nomUsage: PropTypes.string.isRequired,
            prenomUn: PropTypes.string.isRequired,
            prenomDeux: PropTypes.string,
            prenomTrois: PropTypes.string,
            prenomQuatre: PropTypes.string,
            prenomUsuel: PropTypes.string.isRequired,
            sexe: PropTypes.string,
            dateNaissance: PropTypes.string,
            lieuNaissance: PropTypes.string,
            codePostalNaissance: PropTypes.string,
            paysNaissance: PropTypes.shape({
                libelle: PropTypes.string.isRequired,
            }).isRequired,
            nationalite: PropTypes.shape({
                libelle: PropTypes.string.isRequired,
            }).isRequired,
            telephonePrincipal: PropTypes.string,
            telephoneSecondaire: PropTypes.string,
            mail: PropTypes.string,
            adressePrincipale: PropTypes.shape({
                id: PropTypes.number,
                numeroVoie: PropTypes.string,
                extension: PropTypes.string,
                libelleVoie: PropTypes.string,
                lieuDit: PropTypes.string,
                codePostal: PropTypes.string,
                ville: PropTypes.string,
                pays: PropTypes.shape({
                    libelle: PropTypes.string.isRequired,
                }).isRequired,
                justificatifsDomicile: PropTypes.shape({
                    fichiers: PropTypes.arrayOf({
                        uuid: PropTypes.string.isRequired,
                        filename: PropTypes.string.isRequired,
                    }),
                }),
            }).isRequired,
            adressesSecondaires: PropTypes.arrayOf(
                shape({
                    id: PropTypes.number,
                    adresseInternationale: PropTypes.string,
                    numeroVoie: PropTypes.string,
                    extension: PropTypes.string,
                    libelleVoie: PropTypes.string,
                    lieuDit: PropTypes.string,
                    codePostal: PropTypes.string,
                    ville: PropTypes.string,
                    pays: PropTypes.shape({
                        libelle: PropTypes.string.isRequired,
                    }).isRequired,
                }),
            ).isRequired,
            pieceIdentite: PropTypes.shape({
                typePieceIdentite: PropTypes.string,
                numeroPieceIdentite: PropTypes.string,
                piecesIdentiteFichier: PropTypes.arrayOf(
                    PropTypes.shape({
                        uuid: PropTypes.string.isRequired,
                        filename: PropTypes.string.isRequired,
                    }),
                ),
            }),
            certificatMedicalARS: PropTypes.shape({
                uuid: PropTypes.string.isRequired,
                filename: PropTypes.string.isRequired,
            }),
            attestationCompetiteur: PropTypes.shape({
                uuid: PropTypes.string.isRequired,
                filename: PropTypes.string.isRequired,
            }),
        }).isRequired,
        licences: PropTypes.shape({
            permisChasser: PropTypes.shape({
                numero: PropTypes.string.isRequired,
                numeroGuichetUnique: PropTypes.string.isRequired,
                permisChasserFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
                validationPermisChasserFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            }),
            licenceTir: PropTypes.shape({
                numero: PropTypes.string.isRequired,
                isAncienLicencie: PropTypes.bool.isRequired,
                licenceFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            }),
            licenceBallTrap: PropTypes.shape({
                numero: PropTypes.string,
                licenceFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
                isAncienLicencie: PropTypes.bool.isRequired,
            }),
            licenceSki: PropTypes.shape({
                numero: PropTypes.string,
                licenceFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
                isAncienLicencie: PropTypes.bool.isRequired,
            }),
        }),
        hasInjonctionPrefectorale: PropTypes.bool.isRequired,
        typeCompte: PropTypes.string.isRequired,
        informationsMetiersAssociations: PropTypes.shape({
            typeStatut: PropTypes.string,
            federationRattachement: PropTypes.string,
            personneSousStatut: PropTypes.string,
            etablissement: PropTypes.shape({
                actif: PropTypes.bool,
                adressePostal: PropTypes.string,
                adressePrincipale: PropTypes.shape({
                    codePostal: PropTypes.string,
                    complement: PropTypes.string,
                    dateInit: PropTypes.string,
                    dateMaj: PropTypes.string,
                    extension: PropTypes.string,
                    id: PropTypes.number,
                    isPrincipale: PropTypes.bool,
                    justificatifsDomicile: PropTypes.array,
                    latitude: PropTypes.string,
                    libelleVoie: PropTypes.string,
                    lieuDit: PropTypes.string,
                    longitude: PropTypes.string,
                    numVoie: PropTypes.string,
                    pays: PropTypes.shape({
                        code: PropTypes.string,
                        dateInit: PropTypes.string,
                        dateMaj: PropTypes.string,
                        id: PropTypes.number,
                        libelle: PropTypes.string,
                        libelleNormalise: PropTypes.string,
                    }),
                    prefecture: PropTypes.shape({
                        adresse: PropTypes.string,
                        code: PropTypes.string,
                        codePostalMaximum: PropTypes.number,
                        codePostalMinimum: PropTypes.number,
                        email: PropTypes.string,
                        emailArs: PropTypes.string,
                        id: PropTypes.number,
                        labelAdresse: PropTypes.string,
                        libelle: PropTypes.string,
                        nomPrefecture: PropTypes.string,
                        nomPrefectureFormate: PropTypes.string,
                        villePrefecture: PropTypes.string,
                    }),
                    ville: PropTypes.string,
                }),
                adresses: PropTypes.arrayOf(
                    PropTypes.shape({
                        codePostal: PropTypes.string,
                        complement: PropTypes.string,
                        dateInit: PropTypes.string,
                        dateMaj: PropTypes.string,
                        extension: PropTypes.string,
                        id: PropTypes.number,
                        isPrincipale: PropTypes.bool,
                        justificatifsDomicile: PropTypes.array,
                        latitude: PropTypes.string,
                        libelleVoie: PropTypes.string,
                        lieuDit: PropTypes.string,
                        longitude: PropTypes.string,
                        numVoie: PropTypes.string,
                        pays: PropTypes.shape({
                            code: PropTypes.string,
                            dateInit: PropTypes.string,
                            dateMaj: PropTypes.string,
                            id: PropTypes.number,
                            libelle: PropTypes.string,
                            libelleNormalise: PropTypes.string,
                        }),
                        prefecture: PropTypes.shape({
                            adresse: PropTypes.string,
                            code: PropTypes.string,
                            codePostalMaximum: PropTypes.number,
                            codePostalMinimum: PropTypes.number,
                            email: PropTypes.string,
                            emailArs: PropTypes.string,
                            id: PropTypes.number,
                            labelAdresse: PropTypes.string,
                            libelle: PropTypes.string,
                            nomPrefecture: PropTypes.string,
                            nomPrefectureFormate: PropTypes.string,
                            villePrefecture: PropTypes.string,
                        }),
                        ville: PropTypes.string,
                    }),
                ),
                adressesSecondaires: PropTypes.array,
                agrementValide: PropTypes.bool,
                autorisationCommerceValide: PropTypes.bool,
                autorisationExerciceAfci: PropTypes.string,
                autorisationExerciceCnaps: PropTypes.string,
                capital: PropTypes.string,
                categoriePersonne: PropTypes.number,
                dateAgrementCourant: PropTypes.string,
                dateCreation: PropTypes.string,
                dateFermeture: PropTypes.string,
                dateInit: PropTypes.string,
                dateMaj: PropTypes.string,
                email: PropTypes.string,
                employes: PropTypes.array,
                fichierImportArmesEnMasse: PropTypes.array,
                formeJuridique: PropTypes.string,
                id: PropTypes.number,
                isCompteBloque: PropTypes.bool,
                isHabiliteAbandonArme: PropTypes.bool,
                isOperateurCentral: PropTypes.bool,
                nationalite: PropTypes.string,
                nombreParts: PropTypes.string,
                numIdEntreprise: PropTypes.string,
                numSia: PropTypes.string,
                numeroAgrementCourant: PropTypes.string,
                parent: PropTypes.string,
                personnePhysique: PropTypes.string,
                piecesJointes: PropTypes.arrayOf(
                    PropTypes.shape({
                        uuid: PropTypes.string,
                        id: PropTypes.number,
                        libelle: PropTypes.string,
                        fichier: PropTypes.object,
                        typePieceJointe: PropTypes.object,
                    }),
                ),
                prefectureDelivranceAgrementCourant: PropTypes.string,
                raisonSociale: PropTypes.string,
                representantLegal: PropTypes.shape({
                    aDejaEteLicencieTir: PropTypes.bool,
                    adressePrincipale: PropTypes.shape({
                        codePostal: PropTypes.string,
                        complement: PropTypes.string,
                        dateInit: PropTypes.string,
                        dateMaj: PropTypes.string,
                        extension: PropTypes.string,
                        id: PropTypes.number,
                        isPrincipale: PropTypes.bool,
                        justificatifsDomicile: PropTypes.array,
                        latitude: PropTypes.string,
                        libelleVoie: PropTypes.string,
                        lieuDit: PropTypes.string,
                        longitude: PropTypes.string,
                        numVoie: PropTypes.string,
                        pays: PropTypes.shape({
                            id: PropTypes.number,
                            code: PropTypes.string,
                            libelle: PropTypes.string,
                            libelleNormalise: PropTypes.string,
                            dateInit: PropTypes.string,
                            dateMaj: PropTypes.string,
                        }),
                        prefecture: PropTypes.shape({
                            id: PropTypes.number,
                            code: PropTypes.string,
                            libelle: PropTypes.string,
                            villePrefecture: PropTypes.string,
                            email: PropTypes.string,
                            emailArs: PropTypes.string,
                            adresse: PropTypes.string,
                            labelAdresse: PropTypes.string,
                            nomPrefecture: PropTypes.string,
                            nomPrefectureFormate: PropTypes.string,
                            codePostalMinimum: PropTypes.number,
                            codePostalMaximum: PropTypes.number,
                        }),
                        ville: PropTypes.string,
                    }),
                    adresses: PropTypes.array,
                    adressesSecondaires: PropTypes.array,
                    afciPersonnePhysiques: PropTypes.array,
                    attestationCompetiteur: PropTypes.object,
                    autorisationDetentionArme: PropTypes.object,
                    categoriePersonne: PropTypes.number,
                    ceaf: PropTypes.object,
                    certificatMedicalARS: PropTypes.object,
                    cpNaissance: PropTypes.string,
                    dateDeces: PropTypes.string,
                    dateFinCorrectionRatelier: PropTypes.string,
                    dateFusion: PropTypes.string,
                    dateInit: PropTypes.string,
                    dateMaj: PropTypes.string,
                    dateNaissance: PropTypes.string,
                    dateSuppressionPieceJointeApresFusion: PropTypes.string,
                    departementNaissance: PropTypes.string,
                    email: PropTypes.string,
                    fonction: PropTypes.string,
                    id: PropTypes.number,
                    isChasseur: PropTypes.bool,
                    isCompteBloque: PropTypes.bool,
                    isFlagHomonyme: PropTypes.bool,
                    isInscritFiniada: PropTypes.bool,
                    isLicencieTir: PropTypes.bool,
                    isRepresentantLegal: PropTypes.bool,
                    licenceBallTrap: PropTypes.object,
                    licenceTirAvisPrealable: PropTypes.object,
                    licencedeSki: PropTypes.object,
                    licencedeTir: PropTypes.object,
                    lieuNaissance: PropTypes.string,
                    nationalite: PropTypes.string,
                    nom: PropTypes.string,
                    nomUsage: PropTypes.string,
                    numAgrement: PropTypes.string,
                    numFnc: PropTypes.string,
                    numPasseportCni: PropTypes.string,
                    numSia: PropTypes.string,
                    pays: PropTypes.object,
                    paysNaissance: PropTypes.shape({
                        id: PropTypes.number,
                        code: PropTypes.string,
                        libelle: PropTypes.string,
                        libelleNormalise: PropTypes.string,
                        dateInit: PropTypes.string,
                        dateMaj: PropTypes.string,
                    }),
                    permisDeChasse: PropTypes.object,
                    personneFusionnee: PropTypes.object,
                    personneMorales: PropTypes.array,
                    pieceIdentite: PropTypes.shape({
                        typePieceIdentite: PropTypes.string,
                        numeroPieceIdentite: PropTypes.string,
                        dateDelivrance: PropTypes.string,
                        fichiers: PropTypes.array,
                        uuid: PropTypes.string,
                    }),
                    pieceJointeCniPasseport: PropTypes.object,
                    piecesJointes: PropTypes.array,
                    prenomDeux: PropTypes.string,
                    prenomQuatre: PropTypes.string,
                    prenomTrois: PropTypes.string,
                    prenomUn: PropTypes.string,
                    prenomUsuel: PropTypes.string,
                    role: PropTypes.string,
                    sexe: PropTypes.number,
                    telephone: PropTypes.string,
                    telephone2: PropTypes.string,
                    titresDetentions: PropTypes.array,
                    type_personne: PropTypes.string,
                    uniquid: PropTypes.string,
                    uuid: PropTypes.string,
                }),
                representantLegalPrincipal: PropTypes.shape({
                    // Même structure que representantLegal
                    aDejaEteLicencieTir: PropTypes.bool,
                    adressePrincipale: PropTypes.object,
                    adresses: PropTypes.array,
                    adressesSecondaires: PropTypes.array,
                    afciPersonnePhysiques: PropTypes.array,
                    attestationCompetiteur: PropTypes.object,
                    autorisationDetentionArme: PropTypes.object,
                    categoriePersonne: PropTypes.number,
                    ceaf: PropTypes.object,
                    certificatMedicalARS: PropTypes.object,
                    cpNaissance: PropTypes.string,
                    dateDeces: PropTypes.string,
                    dateFinCorrectionRatelier: PropTypes.string,
                    dateFusion: PropTypes.string,
                    dateInit: PropTypes.string,
                    dateMaj: PropTypes.string,
                    dateNaissance: PropTypes.string,
                    dateSuppressionPieceJointeApresFusion: PropTypes.string,
                    departementNaissance: PropTypes.string,
                    email: PropTypes.string,
                    fonction: PropTypes.string,
                    id: PropTypes.number,
                    isChasseur: PropTypes.bool,
                    isCompteBloque: PropTypes.bool,
                    isFlagHomonyme: PropTypes.bool,
                    isInscritFiniada: PropTypes.bool,
                    isLicencieTir: PropTypes.bool,
                    isRepresentantLegal: PropTypes.bool,
                    licenceBallTrap: PropTypes.object,
                    licenceTirAvisPrealable: PropTypes.object,
                    licencedeSki: PropTypes.object,
                    licencedeTir: PropTypes.object,
                    lieuNaissance: PropTypes.string,
                    nationalite: PropTypes.string,
                    nom: PropTypes.string,
                    nomUsage: PropTypes.string,
                    numAgrement: PropTypes.string,
                    numFnc: PropTypes.string,
                    numPasseportCni: PropTypes.string,
                    numSia: PropTypes.string,
                    pays: PropTypes.object,
                    paysNaissance: PropTypes.object,
                    permisDeChasse: PropTypes.object,
                    personneFusionnee: PropTypes.object,
                    personneMorales: PropTypes.array,
                    pieceIdentite: PropTypes.object,
                    pieceJointeCniPasseport: PropTypes.object,
                    piecesJointes: PropTypes.array,
                    prenomDeux: PropTypes.string,
                    prenomQuatre: PropTypes.string,
                    prenomTrois: PropTypes.string,
                    prenomUn: PropTypes.string,
                    prenomUsuel: PropTypes.string,
                    role: PropTypes.string,
                    sexe: PropTypes.number,
                    telephone: PropTypes.string,
                    telephone2: PropTypes.string,
                    titresDetentions: PropTypes.array,
                    type_personne: PropTypes.string,
                    uniquid: PropTypes.string,
                    uuid: PropTypes.string,
                }),
                representantsLegaux: PropTypes.arrayOf(
                    PropTypes.shape({
                        // Même structure que representantLegal
                        aDejaEteLicencieTir: PropTypes.bool,
                        adressePrincipale: PropTypes.object,
                        adresses: PropTypes.array,
                        adressesSecondaires: PropTypes.array,
                        afciPersonnePhysiques: PropTypes.array,
                        attestationCompetiteur: PropTypes.object,
                        autorisationDetentionArme: PropTypes.object,
                        categoriePersonne: PropTypes.number,
                        ceaf: PropTypes.object,
                        certificatMedicalARS: PropTypes.object,
                        cpNaissance: PropTypes.string,
                        dateDeces: PropTypes.string,
                        dateFinCorrectionRatelier: PropTypes.string,
                        dateFusion: PropTypes.string,
                        dateInit: PropTypes.string,
                        dateMaj: PropTypes.string,
                        dateNaissance: PropTypes.string,
                        dateSuppressionPieceJointeApresFusion: PropTypes.string,
                        departementNaissance: PropTypes.string,
                        email: PropTypes.string,
                        fonction: PropTypes.string,
                        id: PropTypes.number,
                        isChasseur: PropTypes.bool,
                        isCompteBloque: PropTypes.bool,
                        isFlagHomonyme: PropTypes.bool,
                        isInscritFiniada: PropTypes.bool,
                        isLicencieTir: PropTypes.bool,
                        isRepresentantLegal: PropTypes.bool,
                        licenceBallTrap: PropTypes.object,
                        licenceTirAvisPrealable: PropTypes.object,
                        licencedeSki: PropTypes.object,
                        licencedeTir: PropTypes.object,
                        lieuNaissance: PropTypes.string,
                        nationalite: PropTypes.string,
                        nom: PropTypes.string,
                        nomUsage: PropTypes.string,
                        numAgrement: PropTypes.string,
                        numFnc: PropTypes.string,
                        numPasseportCni: PropTypes.string,
                        numSia: PropTypes.string,
                        pays: PropTypes.object,
                        paysNaissance: PropTypes.object,
                        permisDeChasse: PropTypes.object,
                        personneFusionnee: PropTypes.object,
                        personneMorales: PropTypes.array,
                        pieceIdentite: PropTypes.object,
                        pieceJointeCniPasseport: PropTypes.object,
                        piecesJointes: PropTypes.array,
                        prenomDeux: PropTypes.string,
                        prenomQuatre: PropTypes.string,
                        prenomTrois: PropTypes.string,
                        prenomUn: PropTypes.string,
                        prenomUsuel: PropTypes.string,
                        role: PropTypes.string,
                        sexe: PropTypes.number,
                        telephone: PropTypes.string,
                        telephone2: PropTypes.string,
                        titresDetentions: PropTypes.array,
                        type_personne: PropTypes.string,
                        uniquid: PropTypes.string,
                        uuid: PropTypes.string,
                    }),
                ),
                telephone: PropTypes.string,
                typeIdEntreprise: PropTypes.string,
                type_personne: PropTypes.string,
                uniquid: PropTypes.string,
                uuid: PropTypes.string,
            }),
        }),
    }),
    isLoading: PropTypes.bool,
    erreur: PropTypes.bool,
    message: PropTypes.string,
    dataSuppression: PropTypes.shape,
};

export default connect(
    (state) => {
        const { isLoading, data: dataCompteUsager } =
            state.monCompte.recupererInformationsPersonnelles;
        const {
            data: dataSuppression,
            erreur,
            message,
        } = state.monCompte.suppressionAdresseSecondaire;
        return {
            isLoading,
            dataCompteUsager,
            erreur,
            message,
            dataSuppression,
        };
    },
    {
        postApi: postAPI,
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(EcranGestion);
